import { useState } from 'react';

/**
 * Az F+ címke az étteremnév mellett. (javitasok-2.0-teljes.md 2.)
 *
 * Az F+ nem mennyiség, hanem jelölő: a liter mindig a Mennyiség oszlopba
 * kerül, a jelölő csak azt dönti el, melyik árral számolunk. A címkére
 * kattintva átáll — a szerver a sor árát is átírja a partner F+ árára,
 * illetve vissza az alapárára.
 *
 *  - F+ sor: kék „F+" címke.
 *  - Alapáras sor, de a partnernek van F+ ára: halvány „F+", kattintásra F+ lesz.
 *  - Ha nincs F+ ára: nem jelenik meg semmi.
 */
export function FpluszJelolo({
  ertek,
  vanAra,
  tiltva,
  onMent,
}: {
  ertek: boolean;
  /** Van-e a partnernek F+ ára a törzsben. */
  vanAra: boolean;
  tiltva?: boolean;
  onMent: (ertek: string) => Promise<void>;
}) {
  const [ment, setMent] = useState(false);

  // Zárolt sornál csak a tényt mutatjuk; alapáras sornál nincs mit jelezni.
  if (!ertek && (!vanAra || tiltva)) return null;

  const cim = tiltva
    ? 'F+ olaj — a partner F+ árával számol.'
    : ertek
      ? 'F+ olaj — a partner F+ árával számol. Kattints, ha mégis alapáras.'
      : 'Alapáras olaj. Kattints, ha F+ — az ár a partner F+ árára vált.';

  return (
    <button
      type="button"
      className={`fpjel${ertek ? ' on' : ''}`}
      disabled={tiltva || ment}
      title={cim}
      onClick={async () => {
        setMent(true);
        try {
          await onMent(ertek ? '0' : '1');
        } catch (hiba) {
          window.alert(hiba instanceof Error ? hiba.message : 'Az F+ jelölő nem menthető.');
        } finally {
          setMent(false);
        }
      }}
    >
      F+
    </button>
  );
}
